import styled from 'styled-components';

import ViewDetailsModal from './../ViewDetailsModal';
import { formatDateFromString } from './../../../../../../utils/formatDateFromString';

interface ComponentProps {
  allQuotes: any[];
  setAllQuotes: (v: any[]) => void;
  data: any;
  setViewDetailsModalShow: (v: boolean) => void;
  viewDetailsModalShow: boolean;
}

const SingleQuoteMobile = ({
  allQuotes,
  setAllQuotes,
  data,
  viewDetailsModalShow,
  setViewDetailsModalShow,
}: ComponentProps) => {
  return (
    <>
      <Wrapper>
        <Row>
          <Label>Date</Label>
          <Colon>:</Colon>
          <InfoValue>{formatDateFromString(data?.createdAt)}</InfoValue>
        </Row>
        <Row>
          <Label>Company Name</Label>
          <Colon>:</Colon>
          <InfoValue> {data?.companyName}</InfoValue>
        </Row>
        <Row>
          <Label>Email</Label>
          <Colon>:</Colon>
          <InfoValue>{data?.email}</InfoValue>
        </Row>
        <ButtonWrapper>
          <ViewButton onClick={() => setViewDetailsModalShow(true)}>
            View Details
          </ViewButton>
        </ButtonWrapper>
      </Wrapper>
      <>
        {!!viewDetailsModalShow && (
          <ViewDetailsModal
            setAllQuotes={setAllQuotes}
            allQuotes={allQuotes}
            data={data}
            setViewDetailsModalShow={setViewDetailsModalShow}
          />
        )}
      </>
    </>
  );
};

export default SingleQuoteMobile;

const Wrapper = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 10px;
  border: 1px solid #ddd;
`;

const Row = styled.div`
  display: flex;
  margin: 3px;
  align-items: center;
`;

const Label = styled.div`
  width: 140px;
  font-size: 16px;
  color: #479adf;
  font-weight: 500;
  font-family: font-medium;
`;

const Colon = styled.div`
  font-size: 16px;
  margin: 0 3px;
  font-weight: 500;
  font-family: font-medium;
`;

const InfoValue = styled.div`
  font-size: 16px;
  font-weight: 900;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-family: font-medium;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const ViewButton = styled.div`
  background-color: rgb(93, 165, 237);
  padding: 5px 10px;
  border-radius: 3px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 500;
  font-family: font-medium;
  &:hover {
    background-color: rgb(33, 112, 190);
  }
`;
